import {createElement, Component, PropTypes} from 'rlink-react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import componentView from 'rlink-router/componentViewMapper.jsx';
import navTo from 'rlink-router/actions/navTo';
import BuildContext from 'rlink-router/BuildContext';

class LegacyNews extends Component {
  componentDidMount () {
    this.props.dispatch(navTo({
      buildContext: this.context.buildContext,
      view: 'news',
      params: {
        filter: 'all',
      },
    }));
  }

  render () {
    return <div></div>;
  }
}
LegacyNews.propTypes = {
  dispatch: PropTypes.func,
};

LegacyNews.contextTypes = {
  buildContext: PropTypes.instanceOf(BuildContext),
};


export default compose(
  componentView(() => ({})),
  connect(),
)(LegacyNews);



// WEBPACK FOOTER //
// ./apps/www.dawnofwar.com/src/views/legacy-news.jsx